import React, {Component} from 'react';
import {config} from '../libs/utils/Const';
import packageJson from '../../package.json';
global.appVersion = packageJson.version;

class Footer extends Component {
    getYear = () => {
        let today = new Date();
        return today.getFullYear() || '';
    };

    render() {
        return (
            <footer className="page-footer font-small pt-4 styleFooter" style={{ marginTop: 50, backgroundColor: config.footer.backgroundColor }}>
                <div className="container text-center text-md-left">
                    <div className="row align-items-center">
                        <div className="col-md text-center">
                            <img src={config.footer.icon} className="img-fluid" />
                        </div>
                        <hr className="clearfix w-100 d-md-none"></hr>
                        <div className="col-md-4">
                            <p>
                                <a>
                                    <i className={config.footer.info.hoursIcon} style={{ color: config.footer.iconColor, paddingRight: 5 }}></i>
                                    <span style={{ color: config.footer.textColor }}>{config.footer.info.hours}</span>
                                </a>
                            </p>
                            <p>
                                <i className={config.footer.info.phoneIcon} style={{ color: config.footer.iconColor, paddingRight: 5 }}></i>
                                <span style={{ color: config.footer.textColor }}>{config.footer.info.phone}</span>
                            </p>
                            <p>
                                <a href={"mailto:" + config.footer.info.email}>
                                    <i className={config.footer.info.emailIcon} style={{ color: config.footer.iconColor, padding: 5 }}></i>
                                    <span style={{ color: config.footer.textColor }}>{config.footer.info.email}</span>
                                
                                </a>
                            </p>
                            <p>
                                <a>
                                    <i className={config.footer.info.addressIcon} style={{color: config.footer.iconColor, padding: 5}}></i>
                                    <span style={{color: config.footer.textColor}}>{config.footer.info.address}</span>
                                </a>
                            </p>
                        </div>
                        <hr className="clearfix w-100 d-md-none"></hr>
                        <div className="col-md-4">
                            {/* <h5 className="font-weight-bold text-uppercase mb-4" style={{ color: config.footer.textColor }}>Redes Sociales</h5> */}
                            <p>
                            {config.footer.socialMedia.visibilityFacebook &&
                                <a href={config.footer.socialMedia.facebook} target="_blank">
                                    <i className={config.footer.socialMedia.facebookIcon} style={{ color: config.footer.iconColor, padding: 15 }}></i>
                                </a>
                            }       
                                {config.footer.socialMedia.visibilityTwitter &&
                                <a href={config.footer.socialMedia.twitter} target="_blank">
                                    <i className={config.footer.socialMedia.twitterIcon} style={{ color: config.footer.iconColor, padding: 15 }}></i>
                                </a>
                                }
                                {config.footer.socialMedia.visibilityInstagram &&
                                <a href={config.footer.socialMedia.instagram} target="_blank">
                                    <i className={config.footer.socialMedia.instagramIcon} style={{ color: config.footer.iconColor, padding: 15 }}></i>
                                </a>
                                }
                                {config.footer.socialMedia.visibilityYoutube &&
                                <a href={config.footer.socialMedia.youtube} target="_blank">
                                    <i className={config.footer.socialMedia.youtubeIcon} style={{ color: config.footer.iconColor, padding: 15 }}></i>
                                </a>
                                }
                            </p>
                        </div>
                        <hr className="clearfix w-100 d-md-none"></hr>
                    </div>
                </div>
                <div className="footer-copyright text-center py-4">
                    <a href="https://fmbsolutions.com.mx/" target="_blank">
                        <img src={config.footer.power} className="img-fluid"/>
                        <br />
                        <span  style={{ color: config.footer.textColor}}>Todos los derechos reservados © {this.getYear()}</span> <br></br>
                        <label className="justify-content-left" ><span style={{ color: config.footer.textColor}} className="text-left font-weight-bold">Versión: &middot; {global.appVersion}</span></label>
                    </a>
                </div> 
            </footer>
        );
    }
}

export default Footer;